module.exports = ".form_pagos{width:330px;height:450px}.form_pagos.modal.active{z-index:10}\n"